import styled from 'styled-components';

import { StyledButton } from '~/components/Button/styles';
import {
  Header as ModalHeader,
  Content as ModalContent,
  Container as ModalContainer,
} from '~/components/Modal/styles';
import { breakpoints } from '~/styles/breakpoints';
import colors from '~/styles/colors';
import grid from '~/styles/grid';

import { Container as HistoryItemContainer } from './HistoryItem/styles';

export const Container = styled.div`
  height: 28.5rem;
  width: 100%;

  h2 {
    font-size: 20px;
    color: #4d4d4d;
  }

  p {
  }

  ${ModalContent} {
    padding: ${grid.lg} ${grid.md};
    max-width: 344px;
  }

  ${ModalHeader} {
    height: 2.1rem;
    padding-left: 10px;
    span {
      font-size: 16px;
      font-weight: bold;
    }

    &::after {
      background-color: transparent;
    }
  }

  .rdrMonth {
    width: 22.8rem;
    height: 17.1rem;
  }
`;

export const Content = styled.div`
  margin-top: 4.2rem;
  display: flex;

  flex-wrap: wrap;
  row-gap: 2.8rem;
  column-gap: ${grid.lg};
  width: 100%;
  padding-bottom: 80px;

  @media (max-width: ${breakpoints.sm}) {
    justify-content: center;
  }
`;

export const ReportList = styled.table`
  border-collapse: collapse;
  width: 100%;
  text-align: left;

  thead {
    th {
      border-bottom: 2px solid ${colors.gray};
      font-size: 12px;
      color: ${colors.gray};
      font-weight: 600;
      padding: 0.7rem 0;
    }
  }
`;

export const RowData = styled.tr`
  svg {
    cursor: pointer;
    transition: ease-in all 0.2s;
    &:hover {
      color: ${colors.primary};
    }
  }

  td {
    height: 4.2rem;
    font-size: 14px;
    color: ${colors.lightblack};
    text-align: left;

    span {
      display: block;
      font-size: 14px;
    }
  }
`;

export const Card = styled.div`
  padding: 0;
  margin: 0;
  box-sizing: border-box;

  display: grid;
  grid-template-rows: 1fr 2fr 1fr;
  padding: 16px;
  box-shadow: 0px 3px 8px #00000029;
  width: 304px;
  height: 164px;
  border-radius: 5px;

  p:after {
    content: none !important;
  }
`;

export const ReportTitle = styled.h1`
  width: 273px;
  height: 21px;
  font-size: 16px;
  margin: 0 0 8px 0;
  color: ${colors.mediumBlack};
`;

export const ReportDescription = styled.p`
  font-size: 12px;
  color: #999999;

  &:after {
    content: none !important;
  }
`;

export const ReportButtons = styled.div`
  display: flex;
  column-gap: 8px;

  ${StyledButton} {
    font-weight: normal;
    font-size: 14px;
    text-transform: none !important;

    &:nth-child(1) {
      width: 103px;
    }

    &:nth-child(2) {
      width: 161px;
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 0 2.1rem;
  bottom: 0;
  width: 100%;
  margin-top: ${grid.md};

  ${StyledButton} {
    width: 10.1rem;
    height: 2.4rem;
    border: none;
    border-radius: 5px;
    font-weight: bold;
    font-size: 14px;
  }
`;

export const SkeletonContainer = styled.div`
  display: grid;

  .SkeletonChild {
    width: 22rem;
  }
`;

export const SkeletonCard = styled.div`
  display: grid;
  grid-template-columns: auto 18px;
  width: 27.9rem;
  height: 5.1rem;
  box-shadow: 0px 3px 6px #00000029;
  padding: 1.1rem;
`;

export const ModalWrapper = styled.div`
  ${ModalContainer} {
    column-gap: 5.7rem;
  }

  ${ModalContent} {
    max-width: 32.1rem;
    padding: 1.7rem;
  }

  ${ModalHeader} {
    font-size: 24px;
    color: #4d4d4d;
    height: 7.1rem;

    span {
      &:nth-child(1) {
        font-size: 24px;
      }

      &:nth-child(2) {
        font-size: 16px;
        font-weight: normal;
        padding: 0.5rem 0;
        margin: 0;
        color: #4d4d4d;
      }
    }

    p {
      font-size: 12px;
      color: #999999;
      margin-bottom: 1.7rem;
      display: inline-block;
    }
  }
`;

export const ModalCards = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;

  ${HistoryItemContainer} {
    &:nth-child(5) {
      margin-bottom: 1.4rem;
    }
  }
`;

export const SkeletonCardContainer = styled.div`
  display: grid;
  grid-template-columns: auto 18px;
  padding: ${grid.md};
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px;
`;

export const NoReportsAvailable = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-top: 20px;
`;
